import gql from 'graphql-tag';

export const SUPER_MATCH_DETAILS_QUERY = gql`
  query superMatchDetailsQuery($accountId: ID!, $superMatchId: ID!) {
    account(id: $accountId) {
      superMatch(id: $superMatchId) {
        id
        superProfile {
          internalName
          publicTitle
          jobProfile {
            id
            name
          }
        }
        assessmentMatchPercentage
        qAndRMatchPercentage
        respondent {
          firstName
          lastName
          email
          contactSuccessRate
        }
        status
        assessment {
          id
          status
          createdOn
          invitedOn
          startedOn
          submittedOn
          compatibleJobProfiles {
            id
            name
          }
          template {
            title
          }

        }
      }
    }
  }
`;

export const SUPER_MATCH_LIST_QUERY = gql`
  query superMatchListQuery($accountId: ID!) {
    account(id: $accountId) {
      superMatches {
        id
        superProfile {
          internalName
          publicTitle
          jobProfile {
            id
            name
          }
        }
        assessmentMatchPercentage
        qAndRMatchPercentage
        respondent {
          firstName
          lastName
          contactSuccessRate
        }
        status
      }
    }
  }
`;

export const SUPER_MATCH_REQUEST_CONTACT_MUTATION = gql`
  mutation superMatchRequestContactMutation($input: SuperMatchRequestContactInput!) {
    requestContact(input: $input) {
      id
    }
  }
`;
